<template>
  <b-modal
    id="update-complete-service-system-standalone-modal"
    cancel-variant="outline-secondary"
    :ok-title="$t('button.confirm')"
    :cancel-title="$t('button.close')"
    centered
    no-close-on-backdrop
    :title="$t('breadcrumb.updateServiceSystem')"
    @ok="handleOk"
    @cancel="handleClose"
    @close="handleClose"
  >
    <template #modal-footer>
      <b-button
        variant="outline-secondary"
        class="btn"
        @click="handleClose"
      >
        {{ $t('button.close') }}
      </b-button>
      <n-button-loading
        :loading="loading"
        class="btn"
        variant="primary"
        :disabled="isUploading"
        @submit="handleOk"
      >
        {{ $t('button.confirm') }}
      </n-button-loading>
    </template>
    <validation-observer
      ref="updateCompleteServiceSystemStandaloneForm"
      #default="{ invalid }"
      @submit.prevent
    >
      <n-form-confirmation
        ref="formConfirmation"
        key="assignOperatorForm"
        novalidate
        :message="
          $t('general.serviceUpdateStatusTo', {
            status: $t(`status.completed`)
          })
        "
        :confirm-button-text="`button.confirm`"
        :cancel-button-text="`button.no`"
        :form="$refs.assignOperatorForm"
        :disabled="invalid"
        @submit="submit"
      >

        <!-- <label class="d-block">
          <span>{{ $t('field.servicePrice') }}</span>
        </label>
        <div
          class="d-flex"
          style="gap: 10px"
        >
          <validation-provider
            v-slot="{ errors }"
            :rules="rules"
            :name="$t('field.servicePrice')"
            class="flex-grow-1"
          >
            <b-form-group>
              <b-form-input
                v-model="data.servicePrice"
                type="number"
                autocomplete="off"
                :placeholder="$t('field.servicePrice')"
                :name="$t('field.servicePrice')"
                :disabled="activeChannel.servicePriceType === 1"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <b-form-group style="min-width: 100px">
            <n-single-select
              :key="activeChannel.id"
              v-model="activeChannel.servicePriceCurrency"
              :options="[
                { value: 'CNY', name: 'CNY' },
                { value: 'USD', name: 'USD' },
                { value: 'KHR', name: 'KHR' },
                { value: 'VND', name: 'VND' }
              ]"
              value="CNY"
              selection-key="value"
              selection-label="name"
              :reduce="true"
              :readonly="activeChannel.servicePriceType !== 3"
            />
          </b-form-group>
        </div> -->

        <n-input
          v-model="data"
          :fields="formInput"
          @image-change="data.remarkMedia = $event"
        >
          <template #remarkMedia>
            <b-form-group>
              <label>
                <span>{{ $t('field.file') }}</span>
                <span class="text-muted"> - {{ $t('field.optional') }} </span>
              </label>
              <n-multiple-file-uploader
                v-model="data.remarkMedia"
                class="mb-1"
                @media-ids="updateRemarkMediaIds"
                @uploading="onUploading"
              />
            </b-form-group>
          </template>
        </n-input>
      </n-form-confirmation>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import NInput from '@/components/NInput.vue'
import useJwt from '@/auth/jwt/useJwt'
import NFormConfirmation from '@/components/NFormConfirmation.vue'
import NButtonLoading from '@/components/NButtonLoading.vue'
import NMultipleFileUploader from '@/components/NMultipleFileUploader.vue'
import ToastificationAvatar from '@core/components/toastification/ToastificationAvatar.vue'
import NSingleSelect from '@/components/NSingleSelect.vue'
import FormInput from './updateServiceSystemCompleteStatusFormInput'

const ServiceSystemRepository = Repository.get('serviceSystem')

export default {
  components: {
    BModal,
    NInput,
    NFormConfirmation,
    BButton,
    NButtonLoading,
    NMultipleFileUploader,
    BFormGroup,
    BFormInput,
    NSingleSelect,
  },
  props: {
    activeRoom: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    activeChannel: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      data: {
        remark: '',
        serviceSystemId: null,
        remarkMedia: [], // Initialize as an array
        remarkMediaIds: [], // Initialize as an array
        servicePrice: null,
      },
      key: 1,
      isUploading: false,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
    rules() {
      return this.activeChannel.servicePriceType === 3
        ? 'required|numeric'
        : `required|numeric|min_value:${this.activeChannel.servicePriceMin}|max_value:${this.activeChannel.servicePriceMax}`
    },
  },
  watch: {
    activeChannel: {
      handler() {
        if (this.activeChannel.servicePriceType === 1) {
          this.data.servicePrice = this.activeChannel.servicePriceMin
        } else {
          // this.data.servicePrice = null;
        }
      },
      deep: true,
    },
  },
  methods: {
    handleClose() {
      // this.activeChannel.servicePriceCurrency = 'CNY'
      this.data.remark = ''
      this.data.remarkMedia = []
      this.data.remarkMediaIds = []
      this.data.servicePrice = null
      this.hide()
    },
    show(id) {
      this.key += 1
      this.data.serviceSystemId = id
      if (this.activeChannel.servicePriceType !== 1) {
        this.data.servicePrice = null
      } else {
        this.data.servicePrice = this.activeChannel.servicePriceMin
      }
      this.$bvModal.show('update-complete-service-system-standalone-modal')
    },
    hide() {
      this.$bvModal.hide('update-complete-service-system-standalone-modal')
    },
    handleOk(bvModal) {
      if (bvModal) bvModal.preventDefault()
      if (this.loading) return

      this.$refs.updateCompleteServiceSystemStandaloneForm
        .validate()
        .then(success => {
          if (success) {
            this.$refs.formConfirmation.confirm()
          }
        })
    },
    updateRemarkMediaIds(mediaIds) {
      this.data.remarkMediaIds = mediaIds
    },
    async submit() {
      this.loading = true

      try {
        const updateData = {
          status: 'completed',
          ...(this.data.remark && { remark: this.data.remark.trim() }),
          ...(this.data.remarkMediaIds.length && {
            remarkMediaIds: this.data.remarkMediaIds,
          }),
          // ...(this.data.servicePrice && {
          //   servicePrice: this.data.servicePrice,
          //   servicePriceCurrency: this.activeChannel.servicePriceCurrency,
          // }),
        }

        const response = await ServiceSystemRepository.updateStatus(
          updateData,
          this.data.serviceSystemId,
        )

        this.$toast({
          component: ToastificationAvatar,
          position: 'top-right',
          timeout: 10000,
          props: {
            title: this.$t('alert.service'),
            icon: 'CastIcon',
            variant: 'success',
            text: this.$t('alert.serviceUpdatedSuccessfully', {
              status: this.$t(`status.${this.data.status || 'completed'}`),
            }),
          },
        })

        this.data.remark = ''
        this.data.remarkMedia = []
        this.data.remarkMediaIds = []
        this.data.servicePrice = null
        this.hide()
        this.$emit('success', response)
      } catch (error) {
        if (error.response?.status === 422) {
          this.$refs.assignOperatorForm.setErrors(
              error.response?.data?.validate,
          )
        }
      } finally {
        this.loading = false
      }
    },
    onUploading(value) {
      this.isUploading = value
    },
  },
  setup() {
    const formInput = [...FormInput]

    return {
      formInput,
    }
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .s-container {
    position: relative;
  }

  .price {
    position: absolute;
    right: 1.575rem;
    top: 3.425rem;
    padding: 0.375rem 0.75rem;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    z-index: 10;
  }
</style>
